interface ErrorLike {
  message?: string;
  details?: Record<string, unknown>;
}

const PROVIDER_MISSING = /has no provider registered yet/i;
const CHANNEL_DISABLED = /is not enabled for hotel/i;

export const isProviderUnavailable = (error: unknown): boolean => {
  if (!error || typeof error !== "object") return false;
  const e = error as ErrorLike;
  const detailMessage =
    typeof e.details?.message === "string" ? (e.details.message as string) : "";
  const message = e.message ?? detailMessage;
  return PROVIDER_MISSING.test(message) || CHANNEL_DISABLED.test(message);
};
